import { toast } from "react-toastify"

import { saveSurveyV2, SurveyResultAnswer } from "modules/NewClientSurvey/common"
import { UserAccount } from "utils/UserAccount"

export function save(answers: SurveyResultAnswer[], slug: string) {
    try {
        return saveSurveyV2({
            slug,
            email: UserAccount.email,
            name: UserAccount.name,
            utm: UserAccount.utm || "undefined",
            answers,
        })
    } catch {
        toast.error(
            "Ошибка при обращении к серверу. Попробуйте повторить действие через некоторое время."
        )
        throw "save survey error"
    }
}
